function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import ActivityIcon from 'svg/activity.svg';
import MealIcon from 'svg/meal.svg';
import InjectionIcon from 'svg/injection.svg';
import PillsIcon from 'svg/pills.svg';
import styles from './RelatedData.pcss';
var _React_PureComponent;
class RelatedData extends (_React_PureComponent = React.PureComponent) {
    get icon() {
        const type = get(this.props, 'data.type');
        switch(type){
            case 'activity':
                return /*#__PURE__*/ _jsx(ActivityIcon, {});
            case 'food':
                return /*#__PURE__*/ _jsx(MealIcon, {});
            case 'injection':
                return /*#__PURE__*/ _jsx(InjectionIcon, {});
            case 'pill':
                return /*#__PURE__*/ _jsx(PillsIcon, {});
            default:
                return null;
        }
    }
    render() {
        const { icon } = this;
        return /*#__PURE__*/ _jsx("div", {
            className: styles.relatedData,
            children: icon
        });
    }
}
_define_property(RelatedData, "propTypes", {
    // Explicit props
    data: PropTypes.shape({
        id: PropTypes.string.isRequired,
        type: PropTypes.oneOf([
            'activity',
            'food',
            'injection',
            'pill'
        ]).isRequired,
        name: PropTypes.string,
        description: PropTypes.string
    })
});
export default withStyles(styles)(RelatedData);
